import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: null, message: "" });
  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });
  
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // Simple front-end validation
    const nextErrors = {};
    if (!name || name.trim().length < 2) nextErrors.name = "Please enter your name";
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailPattern.test(email)) nextErrors.email = "Please enter a valid email";
    if (!message || message.trim().length < 5) nextErrors.message = "Please enter your message";
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length > 0) {
      setStatus({ type: "error", message: props.labels?.validation_error || "Please fix the highlighted fields." });
      return;
    }

    setStatus({ type: null, message: "" });
    setLoading(true); // ← Start loader
  
    emailjs
      .sendForm("service_015xflb", "template_6h3e93h", e.target, "0F4f_D0DZCpPJhN6f")
      .then(
        (result) => {
          console.log("Email successfully sent!", result.text);
          clearState();
          e.target.reset();
          setStatus({ type: "success", message: props.labels?.sent_ok || "Message sent successfully!" });
        },
        (error) => {
          console.log("Failed to send email.", error.text);
          setStatus({ type: "error", message: props.labels?.sent_fail || "Failed to send message. Try again later." });
        }
      )
      .finally(() => setLoading(false)); // ← Stop loader
  };
  
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>{props.labels?.get_in_touch || "Get In Touch"}</h2>
                <p>
                  {props.labels?.get_in_touch_desc ||
                    "Please fill out the form below to send us an email and we will get back to you as soon as possible."}
                </p>
              </div>
              <form name="sentMessage" onSubmit={handleSubmit} noValidate>
                {status.message ? (
                  <div
                    role="status"
                    style={{
                      marginBottom: 15,
                      padding: "10px 12px",
                      borderRadius: 6,
                      color: status.type === "success" ? "#155724" : "#721c24",
                      background: status.type === "success" ? "#d4edda" : "#f8d7da",
                      border: `1px solid ${status.type === "success" ? "#c3e6cb" : "#f5c6cb"}`,
                    }}
                  >
                    {status.message}
                  </div>
                ) : null}
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder={props.labels?.name_placeholder || "Name"}
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger">{errors.name || ""}</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder={props.labels?.email_placeholder || "Email"}
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger">{errors.email || ""}</p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder={props.labels?.message_placeholder || "Message"}
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger">{errors.message || ""}</p>
                </div>
                {/* EmailJS template-friendly hidden aliases */}
                <input type="hidden" name="from_name" value={name} />
                <input type="hidden" name="reply_to" value={email} />
                <input type="hidden" name="time" value={new Date().toLocaleString()} />
                <div id="success"></div>
                <div style={{ display: "flex", gap: "15px", flexWrap: "wrap", marginTop: "20px" }}>
                <button
                  type="submit"
                  className="btn btn-custom btn-lg"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <i className="fa fa-spinner fa-spin" style={{ marginRight: "8px" }}></i>
                      {props.labels?.sending || "Sending..."}
                    </>
                  ) : (
                    props.labels?.send_message || "Send Message"
                  )}
                </button>
                  <a
                    href={props.data?.facebook || "https://facebook.com"}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-custom btn-lg"
                    style={{ textDecoration: "none", display: "inline-block", textAlign: "center" }}
                  >
                    {props.labels?.contact_us_on_facebook || "Contact us on Facebook"}
                  </a>
                </div>
              </form>
            </div>

          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>{props.labels?.contact_info || "Contact Info"}</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> {props.labels?.address || "Address"}
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> {props.labels?.phone || "Phone"}
                </span>{" "}
                {props.data ? <span className="ltr">{props.data.phone}</span> : "loading"}
                <br />
                {props.data ? <span className="ltr">{props.data.phone2}</span> : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-clock-o"></i> {props.labels?.shop_timings || "Shop Timings"}
                </span>
                {props.data && <span className="ltr">{props.data.opening}</span>}
                <br />
                {props.data && <span className="ltr">{props.data.opening2}</span>}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> {props.labels?.email || "Email"}
                </span>{" "}
                {props.data ? <span className="ltr">{props.data.email}</span> : "loading"}
              </p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    {/* <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a> */}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2023 Issaaf Kattan React Land Page Template. Design by{" "}
            <a href="http://www.templatewire.com" rel="nofollow">
              TemplateWire
            </a>
          </p>
        </div>
      </div> */}
    </div>
  );
};

